<template>
  <div class="stock-slip-history-tab py-3">
    <b-overlay :show="loading" rounded="sm">
      <b-table
        :fields="historyFields"
        :items="histories"
        class="table-bordered table-hover col-md-10"
        show-empty
        empty-text="Chưa có lịch sử thay đổi"
      >
        <template #cell(updatedBy)="row">
          <div class="d-flex flex-column">
            <strong>{{ row.item.employeeName || '-' }}</strong>
            <small class="text-muted">{{ row.item.createdAt }}</small>
          </div>
        </template>
        <template #cell(action)="row">
          <b-badge :variant="actionBadgeVariant(row.item.action)">
            {{ row.item.actionName || '-' }}
          </b-badge>
        </template>
        <template #cell(detail)="row">
          <div
            class="orderCode"
            style="cursor: pointer; color: #3699ff; font-weight: 500"
            @click="openHistoryModal(row.item)"
          >
            #{{ row.item.id }}
          </div>
        </template>
      </b-table>
    </b-overlay>

    <StockSlipHistoryModal
      :show.sync="showHistoryModal"
      :history-record="selectedHistory"
      @hidden="selectedHistory = null"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { fetchStockSlipHistories } from '@/core/services/stock-slip-history.service';
import { HISTORY_ACTION_TYPE } from '@/utils/enum';
import { makeToastFaile } from '@/utils/common';
import StockSlipHistoryModal from './StockSlipHistoryModal.vue';

export default {
  name: 'StockSlipHistoryTab',
  components: {
    StockSlipHistoryModal,
  },
  props: {
    stockSlipId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      histories: [],
      showHistoryModal: false,
      selectedHistory: null,
      historyFields: [
        {
          key: 'updatedBy',
          label: 'Người thao tác',
          thStyle: { textAlign: 'center', width: '25%' },
        },
        {
          key: 'action',
          label: 'Hành động',
          thStyle: { textAlign: 'center', width: '35%' },
        },
        {
          key: 'detail',
          label: 'Chi tiết',
          thStyle: { textAlign: 'center', width: '15%' },
        },
      ],
    };
  },
  watch: {
    stockSlipId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadHistories();
        } else {
          this.histories = [];
        }
      },
    },
  },
  methods: {
    async loadHistories() {
      if (!this.stockSlipId) return;
      this.loading = true;
      try {
        const rows = await fetchStockSlipHistories(this.stockSlipId);
        this.histories = (rows || []).map((item) => ({
          ...item,
          createdAt: item.createdAt
            ? moment(String(item.createdAt)).format('DD/MM/YYYY HH:mm')
            : '',
        }));
      } catch (error) {
        const message =
          error?.response?.data?.message || 'Không tải được lịch sử phiếu kho';
        makeToastFaile(message);
        this.histories = [];
      } finally {
        this.loading = false;
      }
    },
    actionBadgeVariant(action) {
      switch (Number(action)) {
        case HISTORY_ACTION_TYPE.CREATE:
          return 'success';
        case HISTORY_ACTION_TYPE.UPDATE:
          return 'warning';
        case HISTORY_ACTION_TYPE.UPDATE_NOTE:
          return 'info';
        case HISTORY_ACTION_TYPE.DELETE:
          return 'danger';
        default:
          return 'secondary';
      }
    },
    openHistoryModal(record) {
      this.selectedHistory = record;
      this.showHistoryModal = true;
    },
  },
};
</script>

<style scoped>
.orderCode:hover {
  text-decoration: underline;
}
</style>
